import {
    ICustomerStoreEventHandler,
    ParcelScannedParameters,
    ParcelStoreCancelledParameters, SendReceiptConfirmedParameters
} from './ICustomerStoreEventHandler';
import {logger} from "../../logger";
import {DhlRestClient} from "../../rest-clients/DhlRestClient";

const log = logger.sub("DhlCustomerStoreEventHandler");

export class DhlCustomerStoreEventHandler implements ICustomerStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<void> {
        log.info(`Called dhl customer store parcel scanned event handler for ${params.parcelId}`);
        const { baseUrl, token } = params.backendApiCredentials;
        const restClient = new DhlRestClient(baseUrl, token);
        const response = await restClient.sendShipmentQuery(params.parcelId, params.cubeId);

        if (!response.ok || !response.body.success) {
            throw new Error(JSON.stringify(response));
        }
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        throw new Error("Dhl carrier store parcel store cancelled event not implemented");
    }

    sendReceiptConfirmed(params: SendReceiptConfirmedParameters): Promise<void> {
        return Promise.resolve(undefined);
    }
}